import { useEffect, useRef, useState } from "react";

export const useProgressiveProductReveal = (itemCount: number, step = 6) => {
  const [visibleCount, setVisibleCount] = useState(() => Math.min(step, itemCount));
  const viewportRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    setVisibleCount(Math.min(step, itemCount));
  }, [itemCount, step]);

  const handleScroll = () => {
    const viewport = viewportRef.current;

    if (!viewport || visibleCount >= itemCount) {
      return;
    }

    const nearEnd = viewport.scrollLeft + viewport.clientWidth >= viewport.scrollWidth - 160;

    if (!nearEnd) {
      return;
    }

    setVisibleCount((current) => Math.min(current + step, itemCount));
  };

  return {
    handleScroll,
    visibleCount,
    viewportRef,
  };
};
